<template>
  <div>
    <header>
      <div id="jevousinvite" class="row">
        <div class="col col-md-3 col-12 text-center">
          <img src="../assets/logo-desktop.png" />
        </div>
        <div class="col col-md-1 col-12 text-center">
          <span class="avatar" id="celine"></span>
        </div>
        <div class="col col-md-8 col-12" id="texte_jevousinvite">
          <font-awesome-icon icon="quote-left" /> 
            <i>&nbsp;&nbsp;&nbsp;&nbsp;Pour en savoir plus sur le métier de conseiller Rivalis,<br />je vous invite à planifier un rendez-vous avec l'un de nos chargés de recrutement.&nbsp;&nbsp;</i> 
          <font-awesome-icon icon="quote-right" />
          <p id="author">Céline, Assistante de recrutement</p>
        </div>
      </div>
    </header>
    <div class="container-fluid">
        <loader v-show="loader"></loader>
        <div v-show="!loader" class="row justify-content-md-center">
            <div v-show="cta">
                <div class="col col-lg-12">
                    <div class='card panel_form_submit'>
                        <div class="card-body">
                            <div class='text-center'>
                                <span id='bt_envoyer'  class='btn' v-on:click='setcta("6mois")'><font-awesome-icon icon="calendar-check" /> <span>Ce n'est pas d'actualité, contactez-moi dans 6 mois</span></span>
                            </div>
                        </div>
                    </div>
                    <div class='card panel_form_submit'>
                        <div class="card-body">
                            <div class='text-center'>
                                <span id='bt_envoyer'  class='btn' v-on:click='setcta("stop")'><font-awesome-icon icon="calendar-check" /> <span>Je ne recherche pas d'opportunités, plus besoin de m'écrire</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="!cta">
                 <div class="col col-lg-12 col-12" id="merci">
                    <p class="note">&nbsp;</p>
                    <p class="note">
                        Merci. 
                    </p>
                    <p class="note"> 
                        Nous avons bien pris note de votre choix. 
                    </p>
                </div>
            </div>
        </div>

      <div class="row justify-content-center">
        <div class="col col-lg-6">
          <p id="legal">
            <small>
              Les informations que je consens transmettre à partir de ce formulaire sont indispensables afin d’être recontacté par la Société BM EST France dans le cadre d’offres d’opportunité professionnelle, notamment par téléphone ou par email. Mes données sont supprimées sous 3 ans à compter de ma dernière prise de contact. Je dispose du droit de demander l’accès, la rectification, la portabilité ou l’effacement de mes données mais également la limitation ou l’opposition au traitement de celles-ci, ainsi que la liste de leurs destinataires le cas échéant, au délégué à la protection des données de la société BM EST France (info@cabinetbouchara.com). Je peux introduire à tout moment une réclamation auprès de la CNIL et définir le sort de mes données après ma mort.
            </small>
          </p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'WrapperCTA',
  props: {
    msg: String
  },
  mounted () {
    this.loader = false
    //var instance = this
    /*
    var payload = new FormData()
    payload.append('cta', this.$route.params.cta)
    var xhr = new XMLHttpRequest()
    
    xhr.open(
        'POST',
        this.access_point + '/prospect/formsourcing/cta',
        true
    )
    xhr.onreadystatechange = function () {
        if (this.readyState === XMLHttpRequest.DONE) {
          if (
              this.status === 408 ||
              this.status === 500 ||
              this.status === 503 ||
              this.status === 504 ||
              this.status === 444 ||
              this.status === 520 ||
              this.status === 521 ||
              this.status === 522
          ) {
              instance.error_upload = 'Erreur de connexion'
              this.bt_envoyer_info = true
              instance.loader = false
          }
          if (this.status === 200) {
              instance.loader = false
              var response = JSON.parse(xhr.responseText)
          }
        }
    }
    xhr.send(payload)
    */
    /*try {
      decodeURIComponent(escape(window.atob( this.$route.params.email )))
    }
    catch (error) {
      window.location = "https://www.rivalis-recrutement.fr"
    }*/
  },
  methods: {
    setcta (choice) {
        this.loader = true
        var instance = this
        var payload = new FormData()
        payload.append('cta', choice)
        payload.append('tulipe', this.$route.params.email)
        var xhr = new XMLHttpRequest()
        xhr.open(
            'POST',
            this.access_point + '/prospect/formsourcing/cta',
            true
        )
        xhr.onreadystatechange = function () {
            if (this.readyState === XMLHttpRequest.DONE) {
            if (
                this.status === 408 ||
                this.status === 500 ||
                this.status === 503 ||
                this.status === 504 ||
                this.status === 444 ||
                this.status === 520 ||
                this.status === 521 ||
                this.status === 522
            ) {
                instance.error_upload = 'Erreur de connexion'
                this.bt_envoyer_info = true
                instance.loader = false
            }
            if (this.status === 200) {
                instance.loader = false
                instance.cta = false
                //var response = JSON.parse(xhr.responseText)
            }
            }
        }
        xhr.send(payload)
    },
    stopecrire () {

    },
    updatemercirappel () {
      this.upload = false
      this.setrt = false
      this.merci = false
      this.mercirappel = true
    },
    updateuploadcv (response) {
      this.upload = false
      if (response["residence"] == "horsunioneuropeenne" || response["residence"] == "unioneuropeenne") {
        this.setrt = false
        this.horsunion = true
      } else {
        this.setrt = true
        this.horsunion = false
      }
      if (response["margueritte"] == false) {
        this.setrt = false
        this.horsunion = true
      }
      this.merci = false
      this.mercirappel = false
      this.id_contact= response["id_contact"]
      this.email = response["email"]
      this.nom = response["nom"]
      this.prenom = response["prenom"]
      this.civilite = response["civilite"]
      this.telephone = response["telephone"]
      //this.$ua.trackView('p2-questions-calendly1', 'p2-questions-calendly1')
    },
    updatesetrt (date) {
      this.upload = false
      this.setrt = false
      this.merci = true,
      this.mercirappel = false,
      this.date = date
      //this.$ua.trackView('p2-questions-calendly1', 'p2-questions-calendly1')
    },
  },
  data () {
    return {
      access_point: "https://recrutement.rivalis.cognix-systems.net",
      source: this.$route.params.source,
      loader: true,
      cta: true,
      upload: false,
      setrt: false,
      horsunion: false,
      merci:false,
      mercirappel:false,
      id_contact: false,
      email: false,
      nom: "",
      prenom: "",
      civilite: "",
      telephone: "",
      date: ""
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
header {
  background: #f2f2f2;
  padding:25px;
  div.col {
    margin-bottom:20px;
  }
}

p#legal {
  margin-top: 20px;
  padding-left: 5px;
  color: #999999;
}

#bt_legal {
  background: none;
  color: black;
  font-size: 80%;
  border:none;
  padding: 0;
  text-decoration: underline;
  color: #999999;
  outline: none !important;
}

#bt_legal:focus {outline:0;}
#bt_legal:active {
outline: none;
border: none;
}

div#jevousinvite {
  font-size: 20px;
  color: #34739f;
  i {
    margin:5px 0;
  }
  span.avatar {
    display: inline-block;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 10px;
    
    &#celine {
      background: url("../assets/celine.jpg") no-repeat center center;
      background-size: 100%;
    }
  }
  p#author {
    color: #909090;
    font-size:14px;
    margin-top:15px;
  }
}

div#merci {
    margin-top:70px;
    p{
        font-size:22px;
    }
    p.note {
        color: #167bc1;
    }
}
</style>
